import React from 'react';
import styled from "styled-components";
import {time_ago, isEmpty} from "@helpers/helpers";
import {Time} from "./grid_card_image";

const GridCardPropertyInfoPriceAndContact = ({property, pricing}) => {


    return (
        <div className="mt-auto d-flex align-items-center justify-content-between">
            <PriceContainer>
                {/*<Time className={`mb-5`}>{time_ago(property.boosted_at, '6_month')}</Time>*/}

                {
                    (pricing.length) ?
                        pricing.map(({price, label, extraLabel}, key) =>
                            (!isEmpty(price)) ?
                                <>
                                    <div className={"d-flex align-items-center justify-content-start mt-4"} key={key}>
                                        <Price className="font-weight-normal">{price.num + ' ' + price.unit + ' ' + label}</Price>
                                    </div>

                                    {
                                        !isEmpty(extraLabel) ?
                                            <Price className="d-block font-12">{extraLabel}</Price>
                                            : ''
                                    }
                                </>
                                : ''
                        )

                        : ''
                }
            </PriceContainer>
        </div>
    );
};

export default React.memo(GridCardPropertyInfoPriceAndContact);

// styles

const Price = styled.span`
   display: block;
   
   @media (max-width: ${props => props.theme.screenXsMax}) {
        //display: inline-block !important;
        margin-top: 0;
   }
`;

const PriceContainer = styled.div`
    margin-top: auto;
    line-height: 1.5;

    @media (max-width: ${props => props.theme.screenXsMax}) {
        position: relative;
        text-align: right;
    }
    
     .price-negotiable-icon {
          &:active, :hover {
			background-color: ${props => props.theme.danger};
		  }

          svg {
              path, g {
                  stroke: ${props => props.theme.dangerText};
              }
          }
     }
`;

const ContactButton = styled.div`
    width: 40px;
    height: 40px;
    border: 1px solid ${props => props.theme.secondary};
    transition: all .1s ease;
    
    i {
        transform: rotateZ(90deg);
    
        svg {
          path{
              stroke: ${props => props.theme.secondary};
              stroke-width: 1;
          }
        }
    }
`;